module.exports = __webpack_public_path__ + "img/시야.14491c15.svg";